/**
 * @file: 画布cube坐标数据库，top最大值按1000cm算，货架最高240cm，远足够了
 * @author: xiaolong.huang@dmall.com
 */

// 物理坐标，第一个货架左下角为基准点算，单位cm
let physicsDB: Map<CubeId, PhysicsCoordinate> = new Map();

// 逻辑坐标，用于参与逻辑坐标运算，易于理解，最大值距离货架底部4000px，单位px
let logicDB: Map<CubeId, LogicCoordinate> = new Map();

export function __getPhysics__(cubeId: CubeId): PhysicsCoordinate|null {
    if (physicsDB.has(cubeId)) {
        return physicsDB.get(cubeId);
    }

    return null;
}

export function __setPhysics__(cubeId: CubeId, coordinate: PhysicsCoordinate): void {
    physicsDB.set(cubeId, coordinate);
}

export function __setLogic__(cubeId: CubeId, coordinate: LogicCoordinate): void {
    logicDB.set(cubeId, coordinate);
}

export function __getLogic__(cubeId: CubeId): LogicCoordinate|null {
    if (logicDB.has(cubeId)) {
        return logicDB.get(cubeId);
    }

    return null;
}

export function __clear__(): void {
    physicsDB.clear();
    logicDB.clear();
}

export function __del__(cubeId: CubeId): void {
    physicsDB.delete(cubeId);
    logicDB.delete(cubeId);
}

export function __has__(cubeId: CubeId): boolean {
    return physicsDB.has(cubeId) && logicDB.has(cubeId);
}

export function __allCubeIds__(): Array<CubeId> {
    return Array.from(physicsDB.keys());
}
